<app-popup-layout>
  @if (secondScreen) {
    <div class="main-container">
      <div class="image-container">
        <img src="/assets/home/freedom-thank-you.png" alt="Card" />
      </div>
      <div class="content-container">
        <div class="close-button-container">
          <img (click)="closeDialog()" class="help-screen-close-button" src="/assets/svg/model-close-btn.svg"
            alt="close" />
        </div>
        <div class="text-container">
          <h2>Thank You</h2>
          <h4>Our Business success team will reach out to you soon.</h4>
        </div>
        <div class="call-to-action">
          <p>For details, check out:</p>
          <button mat-flat-button color="primary" class="custom-button" (click)="goToFreedom()">Experience Freedom</button>
        </div>
      </div>
    </div>
  }

  @if (!secondScreen) {
    <div class="main-container request-demo-container">
      <div class="image-container">
        <img src="/assets/home/freedom-request-demo.png" alt="Card" />
      </div>
      <div class="content-container">
        <div class="close-button-container">
          <img (click)="closeDialog()" class="help-screen-close-button" src="/assets/svg/model-close-btn.svg" alt="close" />
        </div>
        <div class="text-container">
          <div class="title">Corporate Cards</div>
          <div class="items-container">
            <div class="item d-flex">
              <div class="item-bullet">
                <img  src="/assets/home/green-bullet.svg" alt="Card" />
              </div>
              <div class="item-text">
                <div class="item-heading">Customized Integration</div>
                <div class="item-description">Tailor individual cards for specific business needs.</div>
              </div>
            </div>
            <div class="item d-flex">
              <div class="item-bullet">
                <img src="/assets/home/green-bullet.svg" alt="Card" />
              </div>
              <div class="item-text">
                <div class="item-heading">Rewards</div>
                <div class="item-description">Offer upto 10% rewards on every transaction.</div>
              </div>
            </div>
            <div class="item d-flex">
              <div class="item-bullet">
                <img src="/assets/home/green-bullet.svg" alt="Card" />
              </div>
              <div class="item-text">
                <div class="item-heading">Efficiency and Automation</div>
                <div class="item-description">Streamline spend policies and approvals.</div>
              </div>
            </div>
            <div class="item d-flex">
              <div class="item-bullet">
                <img src="/assets/home/green-bullet.svg" alt="Card" />
              </div>
              <div class="item-text">
                <div class="item-heading">Platform</div>
                <div class="item-description">Make Vendor, GST & Utility payments - while earning rewards.</div>
              </div>
            </div>
          </div>
        </div>
        <div class="call-to-action">
          <p>For details, check out:</p>
          <button mat-flat-button color="primary" class="custom-button" (click)="requestDemo()">Request Demo</button>
        </div>
      </div>
    </div>
  }
</app-popup-layout>

